import { Transition } from "@headlessui/react";
import { useContext } from "react";
import { WorkflowContext } from "../../contexts";

function TransitionWorkflowPageSideBar(props: { children: React.ReactNode }) {
  const { showAutomationPanel } = useContext(WorkflowContext);

  return (
    <Transition.Child className={`flex flex-col bg-white h-full w-[360px] flex-shrink-0 p-4 gap-4 overflow-auto border-l border-gray-200 ${showAutomationPanel && "blur-sm"}`}
      enter="transition ease-in-out duration-150 transform"
      enterFrom="translate-x-full"
      enterTo="translate-x-0"
      leave="transition ease-in-out duration-150 transform"
      leaveFrom="translate-x-0"
      leaveTo="translate-x-full"
    >
      {props.children}
      <div className="h-20 flex-shrink-0" aria-hidden />
    </Transition.Child>
  );
}

export default TransitionWorkflowPageSideBar;
